import React from 'react'
import { Typography } from '@mui/material'

interface ErrorMessageProps {
  message?: string | undefined
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ message }) => {
  if (!message || typeof message !== 'string') return null

  return (
    <Typography
      color="error"
      sx={{
        fontSize: '10px',
        fontWeight: 600,
        mt: 0.5
      }}
    >
      {message}
    </Typography>
  )
}

export default ErrorMessage